webpackJsonp([25885102025901],{

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _state = __webpack_require__(79);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _ResultsTemplate = __webpack_require__(29);
	
	var _ResultsTemplate2 = _interopRequireDefault(_ResultsTemplate);
	
	var _dto = __webpack_require__(9);
	
	var dto = _interopRequireWildcard(_dto);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var experienceData = dto.experience(_state2.default.experience);
	var numberOfToolsData = dto.experience(_state2.default.numberOfToolsUsed);
	
	var Results = function Results() {
	    return _react2.default.createElement(_ResultsTemplate2.default, {
	        section: 'State Management',
	        description: '\nState Management regroups all solutions used to manage data, both on client and server.\n\nOn the client *Redux* is still the uncontested leader, but the rise of *GraphQL* might end up shaking\nthings up: the huge wave of interest it\'s generating might help push libraries like *Relay Modern* and *Apollo*\nin the near future. \n            ',
	        keys: _state2.default.keys,
	        experienceData: experienceData,
	        numberOfToolsData: numberOfToolsData,
	        happiness: _state2.default.happiness,
	        sponsor: 'reactforbeginners'
	    });
	};
	
	exports.default = Results;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-2017-state-management-results-js-f4fdb39c02b025da82f4.js